import { render, staticRenderFns } from "./LiveFeed.vue?vue&type=template&id=34944f00&scoped=true"
import script from "./LiveFeed.vue?vue&type=script&lang=js"
export * from "./LiveFeed.vue?vue&type=script&lang=js"
import style0 from "./LiveFeed.vue?vue&type=style&index=0&id=34944f00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34944f00",
  null
  
)

export default component.exports